import {createPreloadableLazyComponent} from '../../../../util/lazyImport';
import type * as Panel2 from '../panel';
import {inputType} from './common';

export const Spec: Panel2.PanelSpec = {
  id: 'artifactVersionTags',
  Component: createPreloadableLazyComponent(() => import('./Component'))
    .Component,
  inputType,
};
